import {defineMessages} from 'react-intl';

const messages = defineMessages({
  'domain-US': {
    id: 'Footer.domain.US',
    defaultMessage: 'United States',
  },
  'domain-DE': {
    id: 'Footer.domain.DE',
    defaultMessage: 'Germany',
  },
  'domain-GB': {
    id: 'Footer.domain.GB',
    defaultMessage: 'United Kingdom',
  },
  'domain-FR': {
    id: 'Footer.domain.FR',
    defaultMessage: 'France',
  },
  'domain-MX': {
    id: 'Footer.domain.MX',
    defaultMessage: 'Mexico',
  },
  'domain-PT': {
    id: 'Footer.domain.PT',
    defaultMessage: 'Portugal',
  },
  'domain-ES': {
    id: 'Footer.domain.ES',
    defaultMessage: 'Spain',
  },
  'domain-IT': {
    id: 'Footer.domain.IT',
    defaultMessage: 'Italy',
  },
  'domain-NL': {
    id: 'Footer.domain.NL',
    defaultMessage: 'Netherland',
  },
  'domain-AT': {
    id: 'Footer.domain.AT',
    defaultMessage: 'Austria',
  },
  'domain-BE': {
    id: 'Footer.domain.BE',
    defaultMessage: 'Belgium',
  },
  'domain-IE': {
    id: 'Footer.domain.IE',
    defaultMessage: 'Republic of Ireland',
  },
  'domain-FI': {
    id: 'Footer.domain.FI',
    defaultMessage: 'Finland',
  },
  'domain-LU': {
    id: 'Footer.domain.LU',
    defaultMessage: 'Luxembourg',
  },
  'domain-GR': {
    id: 'Footer.domain.GR',
    defaultMessage: 'Greece',
  },
  'domain-PL': {
    id: 'Footer.domain.PL',
    defaultMessage: 'Poland',
  },
  'domain-SE': {
    id: 'Footer.domain.SE',
    defaultMessage: 'Sweden',
  },
  'domain-DK': {
    id: 'Footer.domain.DK',
    defaultMessage: 'Denmark',
  },
  'domain-CZ': {
    id: 'Footer.domain.CZ',
    defaultMessage: 'Czech Republic',
  },
  noCurrency: {
    id: 'LocalizationSelector.currencies.none',
    defaultMessage: 'Event currency',
  },
});

export default messages;
